import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/global.css';
import { initI18n } from './lib/i18n/config';
import { App } from './app/App';

// The copy is a separate chunk (see lib/i18n/config), so the first render waits
// for it. It is fetched in parallel with the app's own chunks and is small; the
// alternative is a console that paints untranslated keys for a frame.
void initI18n().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
